import { includes } from "lodash-es";
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import EditCampaignGroup from "./EditCampaignGroup";

const handleSrc = require("images/icons/ui-handle.png");
let triangle = require("images/icons/blue-triangle.png");
triangle = <img src={`/datapulse${triangle}`} />;
let invisTriangle = require("images/icons/invis-triangle.png");
invisTriangle = <img src={`/datapulse${invisTriangle}`} />;

const boxGrip = <img src={`/datapulse${handleSrc}`} className="grip-icon ml-auto" />;

export default function CampaignGroup(props) {
  const name = props.item.name;

  const object = props.item.conditions ? props.item.conditions : { contains: { and: [], or: [] }, not_contains: { and: [], or: [] } };
  let noAnd = object["not_contains"] ? object["not_contains"]["and"] : [];
  let noOr = object["not_contains"] ? object["not_contains"]["or"] : [];
  let containsAnd = object["contains"] ? object["contains"]["and"] : [];
  let containsOr = object["contains"] ? object["contains"]["or"] : [];
  let platformType = props.platformType;
  let groupName = `${name}`;
  return (
    <>
      <Draggable draggableId={props.draggableId} key={props.draggableId} index={props.index}>
        {(provided) => (
          <div {...provided.draggableProps} ref={provided.innerRef} className="d-flex campaign-group campaign-box " xs={12}>
            <div {...provided.dragHandleProps} className=" d-flex flex-column handle  justify-content-center align-items-center ">
              <div className=""> {boxGrip} </div>
            </div>
            <div className=" d-flex py-4 pl-4 " style={{ width: "100%", overflowX: "auto" }}>
              <div className="d-flex flex-column grow " style={{ maxWidth: "100%" }}>
                <div style={{ paddingTop: "3px", paddingBottom: "12px" }} className="align-items-center d-flex">
                  <div>
                    <p className="f18 visby-bold primary">
                      {platformType}: {groupName}
                    </p>
                  </div>
                  <EditCampaignGroup {...props} />
                </div>
                <div className="px-2 pt-2 d-flex initial-condition condition">
                  <div className="d-flex d-inline-block align-items-center d-flex pr-0 pr-md-5 flex-wrap">
                    <p className="f16 nunito-regular primary bold pr-3">Contains:</p>
                    {containsAnd && containsAnd.length > 0
                      ? containsAnd
                          .toString()
                          .split(",")
                          .map((text, index) => {
                            return (
                              <div key={text} style={{ display: "inline-flex" }}>
                                <span className="f16 nunito-regular primary" style={{ marginBottom: "0px" }}>
                                  {text}
                                </span>
                                {index < containsAnd.toString().split(",").length - 1 && (
                                  <span style={{ marginBottom: "3px" }} className="styled-and d-inline-block">
                                    and
                                  </span>
                                )}
                              </div>
                            );
                          })
                      : containsOr
                          .toString()
                          .split(",")
                          .map((text, index) => {
                            return (
                              <div key={text} style={{ display: "inline-flex" }}>
                                <span className="f16 nunito-regular primary" style={{ marginBottom: "0px" }}>
                                  {text}
                                </span>
                                {index < containsOr.toString().split(",").length - 1 && (
                                  <span style={{ marginBottom: "3px" }} className="styled-or d-inline-block">
                                    or
                                  </span>
                                )}
                              </div>
                            );
                          })}
                  </div>
                </div>
                <div className="px-2 py-2 d-flex initial-condition condition">
                  <div className="d-flex d-inline-block align-items-center d-flex pr-0 pr-md-0 flex-wrap">
                    <h6 className="mb-0 f16 pr-3 danger">Does not contain:</h6>
                    {noAnd && noAnd.length > 0
                      ? noAnd
                          .toString()
                          .split(",")
                          .map((text, index) => {
                            return (
                              <div key={text} style={{ display: "inline-flex" }}>
                                <span className="f16 nunito-regular primary" style={{ marginBottom: "0px" }}>
                                  {text}
                                </span>
                                {index < noAnd.toString().split(",").length - 1 && (
                                  <span style={{ marginBottom: "3px" }} className="styled-and d-inline-block">
                                    and
                                  </span>
                                )}
                              </div>
                            );
                          })
                      : noOr
                          .toString()
                          .split(",")
                          .map((text, index) => {
                            return (
                              <div key={text} style={{ display: "inline-flex" }}>
                                <span className="f16 nunito-regular primary" style={{ marginBottom: "0px" }}>
                                  {text}
                                </span>
                                {index < noOr.toString().split(",").length - 1 && (
                                  <span style={{ marginBottom: "3px" }} className="styled-or d-inline-block">
                                    or
                                  </span>
                                )}
                              </div>
                            );
                          })}
                  </div>
                </div>
                <div className="py-2 mb-4 mt-2">
                  {props.platformType == "Social" ? (
                    <p>Custom conversions: {props.item.conversion_objective == "custom_conversions" ? "enabled" : "disabled"}</p>
                  ) : (
                    <p>Custom conversions: {props.item.conversion_actions_enabled ? "enabled" : "disabled"}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-end">
              {props.blueTriangle ? 
                triangle :
                invisTriangle
              }
            </div>
          </div>
        )}
      </Draggable>
    </>
  );
}
